<template>
  <v-dialog
    v-model="show"
    persistent
    max-width="600px"
  >
    <v-card>
      <v-card-title>
        <span class="text-h5">{{ nuevoProyecto.title }}</span>
      </v-card-title>
      <v-card-text>
        <v-container
          v-if="isLoadingGPS"
        >
          <v-row
            justify="center"
          >
            <v-progress-circular
              :size="50"
              color="primary"
              align-self="center"
              indeterminate
            />
          </v-row>
        </v-container>
        <v-container
          v-else
        >
          <template>
            <v-form
              @submit.prevent="submit()"
              ref="form"
              v-model="validNuevoProyecto"
              lazy-validation
            >

              <v-text-field
                v-model="nuevoProyecto.data.nombre"
                :disabled="isEditarProyecto.status"
                label="Nombre del proyecto"
                :rules="[v => !!v || 'Es campo es obligatorio']"
                required
                outlined
              />
              <v-text-field
                v-model="nuevoProyecto.data.direccion"
                label="Dirección del proyecto*"
                :rules="[v => !!v || 'Es campo es obligatorio']"
                required
                outlined
              />
              <v-combobox
                v-model="nuevoProyecto.data.region"
                :items="regiones"
                label="Seleccione la región"
                :disabled="isEditarProyecto.status"
                :rules="[v => !!v || 'Es campo es obligatorio']"
                outlined
                @change="changeRegion"
              />
              <v-combobox
                v-model="nuevoProyecto.data.provincia"
                :items="provincias"
                label="Seleccione la provincia (Excepto región Lima, seleccione distrito) "
                :disabled="isEditarProyecto.status"
                :rules="[v => !!v || 'Es campo es obligatorio']"
                outlined
              />
              <v-select
                v-model="nuevoProyecto.data.tipo"
                :items="$store.state.tipos"
                label="Seleccione el tipo de obra"
                :disabled="isEditarProyecto.status"
                :rules="[v => !!v || 'Es campo es obligatorio']"
                outlined
                required
              />
              <v-select
                v-model="nuevoProyecto.data.categoria"
                :items="$store.state.categorias"
                label="Seleccione la categoría de obra"
                :disabled="isEditarProyecto.status"
                outlined
                :rules="[v => !!v || 'Es campo es obligatorio']"
                required
              />
              <v-select
                v-model="nuevoProyecto.data.etapa"
                :items="$store.state.etapas"
                label="Seleccione la etapa de obra*"
                outlined
                :rules="[v => !!v || 'Es campo es obligatorio']"
                required
              />
              <v-select
                v-model="nuevoProyecto.data.estadoNegociacion"
                :items="$store.state.estadoNegociacion.slice(0,3)"
                label="Seleccione el estado de negociación*"
                outlined
                :rules="[v => !!v || 'Es campo es obligatorio']"
                required
              />
              <v-select
                v-model="nuevoProyecto.data.numeroPisos"
                :items="[1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23,24,25,26,27,28,29,30]"
                label="Indique la cantidad de pisos*"
                outlined
                :rules="[v => !!v || 'Es campo es obligatorio']"
                required
              />
              <v-select
                v-model="nuevoProyecto.data.numeroDepartamentos"
                :items="getNumeroDepartamentos()"
                label="Indique la cantidad de departamentos*"
                outlined
                :rules="[v => !!v || 'Es campo es obligatorio']"
                required
              />
              <v-combobox
                v-model="nuevoProyecto.data.inmobiliaria"
                :items="inmobiliarias"
                hide-selected
                label="Inmobiliaria"
                :rules="[v => !!v || 'Es campo es obligatorio']"
                outlined
              />
              <v-combobox
                v-model="nuevoProyecto.data.constructora"
                :items="constructoras"
                label="Constructora"
                :rules="[v => !!v || 'Es campo es obligatorio']"
                outlined
              />
              <v-combobox
                v-model="nuevoProyecto.data.proveedorActual"
                :items="$store.state.proveedores"
                hide-selected
                label="proveedor"
                :rules="[v => !!v || 'Es campo es obligatorio']"
                outlined
              />
              <v-select
                v-model="nuevoProyecto.data.fechaEntrega"
                :items="entregas"
                label="Seleccione la entrega obra*"
                outlined
                :rules="[v => !!v || 'Es campo es obligatorio']"
                required
              />
              <v-textarea
                v-if="nuevoProyecto.status ===true "
                v-model="nuevoProyecto.data.comment"
                label="Comentario obligatorio, indica los cambios hechos si aplica"
                outlined
                :rules="[v => !!v || 'Es campo es obligatorio']"
                required
              />
              <v-row>
                <v-spacer />
                <div class="mx-3" />
                <v-btn
                  color="danger"
                  @click="$emit('update:show', false)"
                >
                  Cerrar
                </v-btn>
                <v-btn
                  class="mr-4"
                  color="primary"
                  type="submit"
                  :loading="isLoadingSubmit"
                >
                  Crear
                </v-btn>
              </v-row>
              <v-snackbar
                v-model="alertIncompleto"
              >
                Falta llenar campos
              </v-snackbar>
            </v-form>
          </template>
        </v-container>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import firebase from 'firebase'

export default {
  props: ['show', 'isEditarProyecto', 'namesProyectos'],
  data() {
    return {
      entregas: ['P.L', 'S.D',
        'Enero 2025', 'Febrero 2025', 'Marzo 2025', 'Abril 2025', 'Mayo 2025', 'Junio 2025',
        'Julio 2025', 'Agosto 2025', 'Octubre 2025', 'Noviembre 2025', 'Diciembre 2025',
        'Enero 2026', 'Febrero 2026', 'Marzo 2026', 'Abril 2026', 'Mayo 2026', 'Junio 2026',
        'Julio 2026', 'Agosto 2026', 'Octubre 2026', 'Noviembre 2026', 'Diciembre 2026',
        'Enero 2027', 'Febrero 2027', 'Marzo 2027', 'Abril 2027', 'Mayo 2027', 'Junio 2027',
        'Julio 2027', 'Agosto 2027', 'Octubre 2027', 'Noviembre 2027', 'Diciembre 2027',
        'Enero 2028', 'Febrero 2028', 'Marzo 2028', 'Abril 2028', 'Mayo 2028', 'Junio 2028',
        'Julio 2028', 'Agosto 2028', 'Octubre 2028', 'Noviembre 2028', 'Diciembre 2028',
        'Enero 2029', 'Febrero 2029', 'Marzo 2029', 'Abril 2029', 'Mayo 2029', 'Junio 2029',
        'Julio 2029', 'Agosto 2029', 'Octubre 2029', 'Noviembre 2029', 'Diciembre 2029',
        'Enero 2030', 'Febrero 2030', 'Marzo 2030', 'Abril 2030', 'Mayo 2030', 'Junio 2030',
        'Julio 2030', 'Agosto 2030', 'Octubre 2030', 'Noviembre 2030', 'Diciembre 2030'],
      inmobiliarias: [],
      constructoras: [],
      originalProject: {},
      alertIncompleto: false,
      validNuevoProyecto: true,
      regiones: [],
      provincias: [],
      isLoadingSubmit: false,
      titleRegistro: '',
      nuevoProyecto: {
        data: {
          nombre: '',
          comment: '',
        },
      },
      fecha: false,
      isLoadingGPS: false,
      isLoadingCreateProyect: false,
      searchInmobiliaria: null,
      searchConstructora: null,
      searchProveedor: null,
      searchRegiones: null,
      searchProvincias: null,
      searchNamesProyectos: null,
    }
  },
  mounted() {
    this.getRegiones()
    this.nuevoProyecto = this.isEditarProyecto
    this.loadInmobiliariasAndConstructoras()
  },
  methods: {
    getRegiones() {
      this.regiones = []
      this.$store.state.regiones.forEach(region => {
        this.regiones.push(region.NOMBRE)
      })
    },
    changeRegion() {
      this.provincias = []
      var provincia = this.$store.state.regiones.filter(region => region.NOMBRE === this.nuevoProyecto.data.region)
      this.provincias = provincia[0].PROVINCIAS
    },
    cerrar() {
      this.$emit('update:show', false)
    },
    addComment(codigo, comentario) {
      const texto = (comentario || '').trim();
      const user = JSON.parse(localStorage.userAuth);
      const newComment = {
        usuario: user.email,
        createdAt: firebase.firestore.Timestamp.fromDate(new Date()),
        comment: texto,
      };

      firebase.firestore().collection('proyectos').doc(codigo).update({
        comments: firebase.firestore.FieldValue.arrayUnion(newComment),
      }).then(() => {
        firebase.firestore().collection('proyectos').doc(codigo).get().then(doc => {
          if (doc.exists) {
            const data = doc.data();
            this.commentsProyecto = data.comments || [];
          }
        });
      });
    },
    submit() {
      if (!this.$refs.form.validate()) {
        this.alertIncompleto = true;
        return;
      }
      this.isLoadingSubmit = true;
      const user = JSON.parse(localStorage.userAuth);
      const codigo = this.nuevoProyecto.status === true
        ? this.nuevoProyecto.data.codigo
        : this.generateRandomString(15);

      const commonData = {
        nombre: this.nuevoProyecto.data.nombre.toUpperCase(),
        direccion: this.nuevoProyecto.data.direccion.toUpperCase(),
        region: this.nuevoProyecto.data.region.toUpperCase(),
        provincia: this.nuevoProyecto.data.provincia.toUpperCase(),
        tipo: this.nuevoProyecto.data.tipo.toUpperCase(),
        categoria: this.nuevoProyecto.data.categoria.toUpperCase(),
        estado: this.nuevoProyecto.data.estado,
        numeroPisos: this.nuevoProyecto.data.numeroPisos,
        numeroDepartamentos: this.nuevoProyecto.data.numeroDepartamentos,
        etapa: this.nuevoProyecto.data.etapa.toUpperCase(),
        estadoNegociacion: this.nuevoProyecto.data.estadoNegociacion.toUpperCase(),
        entrega: this.nuevoProyecto.data.fechaEntrega,
        inmobiliaria: this.nuevoProyecto.data.inmobiliaria.toUpperCase(),
        constructora: this.nuevoProyecto.data.constructora.toUpperCase(),
        proveedorActual: this.nuevoProyecto.data.proveedorActual.toUpperCase(),
        dateFechaCotizacion: null,
        dateFechaFacturacion: null,
        tipoVivienda: null,
        ipv: null,
        cantidadPuertas: 0,
        montoPuertas: 0,
        montoCortafuego: 0,
        reunion: '',
        tipoSistema: null,
        tipoCliente: null,
        medioContacto: null,
        posibilidadCierre: 0,
        quienGano: '',
        razonPerdido: '',
      };

      const db = firebase.firestore();
      const contactosRef = db.collection('contacts');
      const inmobiliariaNombre = commonData.inmobiliaria;
      const constructoraNombre = commonData.constructora;

      const promesasContacto = [];

      if (inmobiliariaNombre) {
        promesasContacto.push(
          contactosRef.doc(inmobiliariaNombre).get().then(snapshot => {
            if (!snapshot.exists) {
              return contactosRef.doc(inmobiliariaNombre).set({
                nombre: inmobiliariaNombre,
                type: 1
              });
            }
          })
        );
      }

      if (constructoraNombre) {
        promesasContacto.push(
          contactosRef.doc(constructoraNombre).get().then(snapshot => {
            if (!snapshot.exists) {
              return contactosRef.doc(constructoraNombre).set({
                nombre: constructoraNombre,
                type: 2
              });
            }
          })
        );
      }

      Promise.all(promesasContacto).then(() => {
        let automaticComment = '';
        let manualComment = '';

        if (this.nuevoProyecto.status === true) {
          db.collection('proyectos').doc(codigo).get().then(doc => {
            if (!doc.exists) return;

            const originalProyecto = doc.data();
            const cambios = [];
            const camposAComparar = ['direccion', 'estado', 'numeroPisos', 'numeroDepartamentos', 'estadoNegociacion', 'fechaEntrega', 'inmobiliaria', 'constructora', 'proveedorActual'];

            camposAComparar.forEach(campo => {
              const nuevo = this.nuevoProyecto.data[campo];
              const original = originalProyecto[campo];
              if (nuevo && nuevo !== original) {
                cambios.push(`${campo} a ${nuevo}`);
              }
            });

            automaticComment = cambios.length > 0
              ? `⚙️ Se editó:\n ${cambios.join('\n')}`
              : 'No se realizaron cambios.';

            manualComment = this.nuevoProyecto.data.comment ? this.nuevoProyecto.data.comment.trim() : 'No hay comentario manual.';

            const newAutomaticComment = {
              usuario: user.email,
              createdAt: firebase.firestore.Timestamp.fromDate(new Date()),
              comment: automaticComment,
            };

            const newManualComment = {
              usuario: user.email,
              createdAt: firebase.firestore.Timestamp.fromDate(new Date()),
              comment: manualComment,
            };

            db.collection('proyectos').doc(codigo).set({
              ...commonData,
              comments: firebase.firestore.FieldValue.arrayUnion(newAutomaticComment, newManualComment),
            }, { merge: true }).then(() => {
              this.logAutomaticComment(codigo, automaticComment, {
                ...commonData,
                codigo,
                asesor: user.email,
                prospector: user.email,
              });
              this.$emit('actualizarTable', true);
              this.isLoadingSubmit = false;
              this.cerrar();
            }).catch(() => {
              this.isLoadingSubmit = false;
            });
          }).catch(() => {
            this.isLoadingSubmit = false;
          });

        } else {
          const newAutomaticComment = {
            usuario: user.email,
            createdAt: firebase.firestore.Timestamp.fromDate(new Date()),
            comment: '⚙️ Proyecto Creado',
          };

          const fullNewProject = {
            ...commonData,
            codigo: codigo,
            prospector: user.email,
            asesor: user.email,
            latitud: this.nuevoProyecto.data.latitud,
            longitud: this.nuevoProyecto.data.longitud,
            planos: 'no',
            metrados: 'no',
            visitas: [],
            foto: '',
            fase: 1,
            fechaCreacion: '',
            fechaEdicion: '',
            montoCerraduras: 0,
            comments: firebase.firestore.FieldValue.arrayUnion(newAutomaticComment),
          };
          db.collection('proyectos').doc(codigo).set(fullNewProject, { merge: true }).then(() => {
            this.logAutomaticComment(codigo, '⚙️ Proyecto Creado', fullNewProject);
            this.$emit('actualizarTable', true);
            this.isLoadingSubmit = false;
            this.cerrar();
          }).catch(() => {
            this.isLoadingSubmit = false;
          });
        }
      }).catch(() => {
        this.isLoadingSubmit = false;
      });
    },
    logAutomaticComment(codigo, comentario, proyectoData) {
      const user = JSON.parse(localStorage.userAuth);
      const logData = {
        codigoProyecto: codigo,
        nombreProyecto: proyectoData.nombre || '',
        comentario: comentario,
        usuario: user.email,
        perfil: user.perfil,
        fecha: firebase.firestore.Timestamp.fromDate(new Date()),
        estadoNegociacion: proyectoData.estadoNegociacion || '',
        constructora: proyectoData.constructora || '',
        inmobiliaria: proyectoData.inmobiliaria || '',
        tipo: proyectoData.tipo || '',
        region: proyectoData.region || '',
        provincia: proyectoData.provincia || '',
        fase: proyectoData.fase || 1,
        asesor: proyectoData.asesor || user.email,
        prospector: proyectoData.prospector || user.email
      };

      return firebase.firestore().collection('globalLog').add(logData);
    },
    generateRandomString(num) {
      const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
      let result1 = '';
      const charactersLength = characters.length;
      for (let i = 0; i < num; i++) {
        result1 += characters.charAt(Math.floor(Math.random() * charactersLength));
      }
      return result1;
    },
    getNumeroDepartamentos() {
      var departamentos = [];
      for (var i = 0; i < 300; i++) {
        departamentos.push(i);
      }
      return departamentos;
    },
    async loadInmobiliariasAndConstructoras() {
      try {
        const inmobiliariasSnapshot = await firebase.firestore().collection('proyectos').get();
        const inmobiliariasData = inmobiliariasSnapshot.docs.map(doc => doc.data().inmobiliaria);
        const constructorasData = inmobiliariasSnapshot.docs.map(doc => doc.data().constructora);

        this.inmobiliarias = [...new Set(inmobiliariasData)];
        this.constructoras = [...new Set(constructorasData)];
      } catch (error) {
        console.error('Error cargando inmobiliarias y constructoras: ', error);
      }
    },
    async addInmobiliaria(newInmobiliaria) {
      if (!newInmobiliaria) return;
      const empresaId = newInmobiliaria.trim().replace(/\s+/g, ' ').toUpperCase();
      try {
        /* await firebase.firestore().collection('proyectos').add({
          inmobiliaria: newInmobiliaria
        }); */
        await firebase.firestore().collection('contacts').doc(empresaId).set({
          nombre: newInmobiliaria,
          type: 1,
        }, { merge: true });

        this.inmobiliarias.push(newInmobiliaria);
      } catch (error) {
        console.error('Error al agregar inmobiliaria:', error);
      }
    },
    async addConstructora(newConstructora) {
      if (!newConstructora) return;
      const empresaId = newConstructora.trim().replace(/\s+/g, ' ').toUpperCase();
      try {
        /* await firebase.firestore().collection('proyectos').add({
          constructora: newConstructora
        }); */
        await firebase.firestore().collection('contacts').doc(empresaId).set({
          nombre: newConstructora,
          type: 2,
        }, { merge: true });

        this.constructoras.push(newConstructora);
      } catch (error) {
        console.error('Error al agregar constructora:', error);
      }
    },
  }
}
</script>

